export default "__VITE_ASSET__Br3J3oOP__"